import { useEffect, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { tenantsAPI } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';
import TenantBrandingFields, { TenantBrandingValue } from './TenantBrandingFields';
import toast from 'react-hot-toast';

export default function TenantBrandingSettings() {
  const { tenant } = useAuth();
  const cache = useQueryClient();
  const [branding, setBranding] = useState<TenantBrandingValue>({});
  const [uploading, setUploading] = useState(false);
  const { data, isLoading, isError } = useQuery({ queryKey: ['tenant-branding', tenant?.id], queryFn: async () => (await tenantsAPI.getMe()).data, enabled: !!tenant });
  useEffect(() => { if (data) setBranding({ logo_url: data.logo_url || '', mostra_nome_tenant: data.mostra_nome_tenant ?? true, colore_primario: data.colore_primario || '#2563eb', colore_secondario: data.colore_secondario || '#1e40af' }); }, [data]);
  const save = useMutation({
    mutationFn: () => tenantsAPI.updateMe({ ...branding, logo_url: branding.logo_url || null }),
    onSuccess: (response) => { cache.setQueryData(['tenant-branding', tenant?.id], response.data); cache.invalidateQueries({ queryKey: ['tenant-branding'] }); cache.invalidateQueries({ queryKey: ['tenant', 'me'] }); toast.success('Branding aggiornato'); },
    onError: () => toast.error('Impossibile salvare il branding'),
  });
  if (isLoading) return <p>Caricamento…</p>;
  if (isError) return <p role="alert">Impossibile caricare il branding.</p>;
  return <form onSubmit={(event) => { event.preventDefault(); save.mutate(); }} className="max-w-xl space-y-5 rounded-lg bg-white p-6 shadow">
    <h2 className="text-lg font-semibold">Branding</h2>
    <p className="text-sm text-gray-500">Personalizza logo, nome e colori dell’app.</p>
    <TenantBrandingFields tenantId={tenant?.id} value={branding} onChange={(changes) => setBranding((current) => ({ ...current, ...changes }))} onBusyChange={setUploading} />
    <button type="submit" disabled={uploading || save.isPending} className="rounded-lg bg-primary-600 px-4 py-2 text-sm text-white disabled:opacity-50">Salva branding</button>
  </form>;
}
